var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhiteQuotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 91.586,
    height: 72.605,
    viewBox: "0 0 91.586 72.605",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_171807",
    "data-name": "\\uADF8\\uB8F9 171807",
    transform: "translate(1007.546 1397.888) rotate(180)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_171809",
    "data-name": "\\uADF8\\uB8F9 171809",
    transform: "translate(915.96 1325.282)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\uD569\\uCE58\\uAE30_37",
    "data-name": "\\uD569\\uCE58\\uAE30 37",
    d: "M0,72.605V38.285q0-.095,0-.2v-.966H.017C.231,30.106,2.863,4.885,29.417,0a93.221,93.221,0,0,1,4.145,11.611S16.2,13.268,18.21,37.117H36.129V72.605Z",
    transform: "translate(0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\uD569\\uCE58\\uAE30_38",
    "data-name": "\\uD569\\uCE58\\uAE30 38",
    d: "M0,72.605V38.285q0-.095,0-.2v-.966H.017C.231,30.106,2.863,4.885,29.417,0a93.221,93.221,0,0,1,4.145,11.611S16.2,13.268,18.21,37.117H36.129V72.605Z",
    transform: "translate(55.456)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteQuotes);
export default __webpack_public_path__ + "static/media/whiteQuotes.c7828e77a6ad1b4a962755a8d35d8130.svg";
export { ForwardRef as ReactComponent };